import ImageListItem from '@mui/material/ImageListItem';
import { styled } from '@mui/material';
import { ZIndexes } from 'enums/z-indexes';
import { Grid, Typography } from '@mui/material';

export const OverviewItem = styled(ImageListItem)({
  height: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
  zIndex: ZIndexes.Internal_One,
});

export const OverviewItemGrid = styled(Grid)(({ theme }) => ({
  border: '2.264px solid #FFFFFF',
  borderRadius: '7.5px',
  padding: '7px 14px',
  background: '#272727',
  [theme.breakpoints.up('sm')]: {
    padding: '14px 28px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '7px 14px',
  },
}));

export const OverviewItemText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Modak',
  WebkitTextStroke: '1px #272727',
  fontSize: '28px',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    fontSize: '21px',
  },
}));

export const OverviewEmojiGrid = styled(Grid)(({ theme }) => ({
  fontSize: '30px',
  textAlign: 'center',
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '40px',
  },
}));
